<template>
  <div>
    <div class="alert alert-success mb-0" v-show="success">{{ success }}</div>
    <div class="alert alert-danger mb-0" v-show="error">{{ error }}</div>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="row">
          <form id="form" :action="api+'api/v1/create/reseller'">
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.details }} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.name || 'Name' }}</label>
                    <input type="text" name="name" class="form-control" maxlength="30" required="" placeholder="Bayi adı">
                  </div>
                  <div class="form-group" style="display: none;">
                    <label for="">Haftalık Limit</label>
                    <input type="number" name="weekly_limit" class="form-control" required="" placeholder="Bayinin haftalık sabit limiti" value="0">
                  </div>
                  <div class="form-group" style="display: none;">
                    <label for="">Güncel Limit</label>
                    <input type="number" name="current_limit" class="form-control" required="" placeholder="Bayinin güncel limiti" value="0">
                  </div>
                  <div class="form-group">
                    <label for="">Telefon</label>
                    <input type="text" name="phone" class="form-control" maxlength="15" value="">
                  </div>
                  <div class="form-group">
                    <label for="">{{ t.details || 'Details'}}</label>
                    <textarea name="detail" class="form-control" rows="5"></textarea>
                  </div>
                  <div class="form-group">
                    <div class="toggle btn btn-success" data-toggle="toggle" style="width: 115.383px; height: 35.5px;">
                      <input type="checkbox" name="atim_cekim" checked="" data-toggle="toggle" data-on="Atım Aktif" data-off="Atım Pasif" data-onstyle="success" data-offstyle="danger">
                      <div class="toggle-group">
                        <label class="btn btn-success toggle-on">{{ t.custom_reseller_panel.transfer_active }}</label>
                        <label class="btn btn-danger active toggle-off">{{ t.custom_reseller_panel.transfer_passive }}</label>
                        <span class="toggle-handle btn btn-default"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.informations }} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.user.username }}</label>
                    <input type="text" name="username" class="form-control" maxlength="20" required="" v-model="username">
                  </div>
                  <div class="form-group">
                    <label for="">{{ t.custom_reseller_panel.password || 'Password'}}</label>
                    <div class="input-group">
                      <input type="text" class="form-control" name="password" maxlength="20" required="" v-model="password">
                      <span class="input-group-btn">
                      <button class="btn btn-link" type="button" id="generatePassword" @click="generatePasswordFx()">
                      {{ t.custom_reseller_panel.generate_password }}</button>
                      <span id="generatePasswordEditMode"></span>
                </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header"> {{ t.navigation.roles_list }} </div>
                <div class="card-block">
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="active" checked=""> {{ t.custom_reseller_panel.is_active }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="role_user_status"> {{ t.custom_reseller_panel.role_account_enable }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="role_money_transfer"> {{ t.custom_reseller_panel.role_money_transfer }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="role_user_pass_reset"> {{ t.custom_reseller_panel.role_password_reset }} </label>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="role_betslip_configuration"> {{ t.custom_reseller_panel.role_betslip_configuration || 'Betslip Limits' }} </label>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card card-block">
                <button type="submit" class="btn btn-success" id="form-submit-button">{{ t.edit_and_save }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerSearch from "../CustomerSearch";
export default {
  name: "ResellerCreate",
  components: {CustomerSearch},
  data () {
    return {
      api: window.api,
      t: this.$root.t,
      error: null,
      success: null,
      password: null
    }
  },
  mounted() {
    this.submitForm()
  },
  methods: {
    generatePasswordFx(){
      var number = this.generatePassword(10);

      this.password = number;
    },
    findUser(u){
      this.dealer_id = u.id;
    },
    submitForm(){
      const form = document.querySelector("#form");
      form.addEventListener("submit", e => {
        e.preventDefault();
        const fd = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", e => {

          if(e.currentTarget.status === 200)
            this.$router.replace({name: 'ResellerList'})

          if(e.currentTarget.status === 400){
            this.error = JSON.parse(e.target.responseText).error;

            setTimeout(() => {
              this.error = null;
            }, 5000)
          }
        });
        xhr.addEventListener("error", e => {
          console.log(e);
          this.error = JSON.parse(e.target.responseText).error;
        });
        xhr.open("POST", form.action, false);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('Accept-Language', session.locale.locale)
        xhr.setRequestHeader('Authorization', 'Bearer ' + window.auth.accessToken)
        xhr.send(this.urlencodeFormData(fd));
      });
    },
      urlencodeFormData(fd){
      var params = new URLSearchParams(fd);
      return params.toString();
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/ResellerCreate.vue